module.exports = __webpack_public_path__ + "img/logo-insight.f7273532.png";